import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { CheckboxGroup } from '../form/input/checkbox-group/checkbox-group';
import { RadioGroup } from '../form/input/radio-group';
import { useGroupOptions } from './hooks/use-group-options';
const b = bemClassBuilder('v-filter-option-list');
export const FilterOptionList = observer(props => {
    const { filterKey, isMultiselect, options, onChange, attributeIconCdnOptions, allOptionLabel } = props;
    const onChangeHandler = (event) => {
        const numberValue = Number(event.target.value);
        const useNumberValue = !!options.find(option => option.value === numberValue);
        const value = useNumberValue ? numberValue : event.target.value;
        onChange(filterKey, value, event.target.checked, isMultiselect);
    };
    const selectedOptions = options.filter(o => o.selected).map(o => o.value);
    const groupOptions = useGroupOptions(options, filterKey, attributeIconCdnOptions, allOptionLabel, b.element('icon'));
    const baseGroupProps = {
        name: filterKey,
        options: groupOptions,
        value: selectedOptions[0],
        selectedOptions,
        onChange: onChangeHandler,
        className: b.block()
    };
    return isMultiselect ? _jsx(CheckboxGroup, Object.assign({}, baseGroupProps)) : _jsx(RadioGroup, Object.assign({}, baseGroupProps));
});
FilterOptionList.displayName = 'FilterOptionList';
